import { css } from 'css-literal-loader/styled';
import React from 'react';
import Layout from '@4c/layout';

const HEIGHT = 100;

const styles = require('./FadeScroller-styles.module.scss');
const propTypes = {};

class FadeScroller extends React.Component {
  fader = React.createRef();

  scroller = React.createRef();

  handleScroll = ({ target }) => {
    cancelAnimationFrame(this.timer);
    this.timer = requestAnimationFrame(() => {
      const node = this.fader.current;
      const { scrollTop, offsetHeight } = target;
      const bottom = scrollTop + offsetHeight;

      const leftToScroll = Math.max(0, target.scrollHeight - bottom);
      if (leftToScroll >= HEIGHT) {
        node.style.transform = '';
      } else if (leftToScroll <= HEIGHT) {
        const p = leftToScroll / HEIGHT;
        node.style.transform = `translateY(${(1 - p) * 100}%)`;

        if (this.props.onScrollBottom) {
          this.props.onScrollBottom();
        }
      }
    });
  };

  render() {
    const { children } = this.props;

    return (
      <>
        <Layout.Block
          grow
          className={styles.scroller}
          onScroll={this.handleScroll}
          ref={this.scroller}
        >
          {children}
          <div className={styles.fader} ref={this.fader} />
        </Layout.Block>
      </>
    );
  }
}

FadeScroller.propTypes = propTypes;

export default FadeScroller;
